import Snappy from '../../../libs/snappy/snappy';
import { bindAll } from 'underscore';

Snappy.Component.SocialShare = class SocialShare extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-social-share';
	}

	constructor(element) {
		super(element);
	}

	setVars() {
		this.$total = this.$element.find('.total-count__number');
		this.addEventListeners();
	}

	addEventListeners() {
		window.addthis.addEventListener('addthis.ready', this.onAddThisReady.bind(this));
	}

	render() {
		bindAll(this, 'detectAddThisElements');
		this.setVars();
		this.fetchTotalShares();
	}

	fetchTotalShares() {
		window.addthis.sharecounters.getShareCounts('facebook', this.onShareServiceResponse.bind(this));
	}

	onAddThisReady() {
		this.detectAddThisElements();
	}

	detectAddThisElements() {
		let $elements = this.$element.find('.at-share-btn');

		if ($elements.length) {
			$elements.attr('tabindex', 0);
		} else {
			window.setTimeout(this.detectAddThisElements, 200);
		}
	}

	onShareServiceResponse(data) {
		let content;

		if (data && data.count) {
			content = data;
		} else {
			content = 0;
		}

		this.$total.text(content);
	}
};



// WEBPACK FOOTER //
// ./components/socialShare/scripts/socialShare.js